"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRANSITION_DURATION_MS = exports.TRANSITION_DURATION_MS = 300;
var TRANSITION_SCALE_ADJUSTMENT_Y = exports.TRANSITION_SCALE_ADJUSTMENT_Y = 0.2;
var TRANSITION_SCALE_ADJUSTMENT_X = exports.TRANSITION_SCALE_ADJUSTMENT_X = 0.5;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Menu/constants.js
// module id = 72
// module chunks = 0